import { Br } from "@/components/molecules/Br";
import { Container } from "@/components/molecules/Container";
import { Inner } from "@/components/molecules/Inner";
import { BreadCrumb } from "@/components/organisms/BreadCrumb";
import Careers from "@/components/organisms/Careers";
import Contact from "@/components/organisms/Contact";
import { ProjectNav } from "@/components/organisms/ProjectNav";
import { Footer } from "@/components/templates/Footer";
import { Header } from "@/components/templates/Header";
import Layout from "@/components/templates/Layout";
import Meta from "@/components/templates/Meta";
import { useBudouX } from "@/hooks/useBudouX";
import Image from "next/image";

// images
import { Interviewee, Interviewer } from "@/components/organisms/InterviewItem";
import { ProjectCover } from "@/components/organisms/ProjectCover";
import projectIllust2 from "/public/project-illust2.webp";

export default function ProjectArticle2(props) {
  const { parse } = useBudouX();
  const isHeaderRelative = true;
  return (
    <>
      <Meta
        pageTitle={"ペーパーからクラウドへ。最適な設計とシステムのご提案。"}
        pageDescription={
          "株式会社トッカシステムズのプロジェクト事例。ペーパーからクラウドへ。最適な設計とシステムのご提案。日進月歩のデジタルテクノロジー分野において『お客様のビジネスに特化（Tocca）したシステムを』という理念を社名に込めて、使える・価値のあるシステムを提供します。"
        }
        pagePath={"https://tocca.systems/project/2"}
        imgUrl={"/public/project-illust2.webp"}
      />
      <Layout>
        <Header isRelative={isHeaderRelative} />
        <main className="flex-1">
          <Container>
            <BreadCrumb
              lists={[
                {
                  name: "TOP",
                  path: "/",
                },
                {
                  name: "Project",
                  path: "/project/",
                },
                {
                  name: "ペーパーからクラウドへ。最適な設計とシステムのご提案。",
                },
              ]}
            />
            <Inner className="pt-0 pb-10 md:pt-6 md:pb-20">
              {/* cover */}
              <ProjectCover
                id="2"
                href="/career/voice/2"
                title="ペーパーからクラウドへ。<br />最適な設計とシステムのご提案。"
                intro="これまで紙で行っていた、申請の手続きをクラウド化するという、業務フロー改善のプロジェクト。<br class='tbpc' />トッカシステムズでは、最適なシステムの提案とバックエンドとフロントエンド実装を行いました。"
                src="/project-keyVisual2.svg"
                imageClassName="2xs:right-[14px] 2xs:top-[14px] xs:right-[15px] xs:top-[20px] aspect-1/1 2xs:w-[76px] xs:w-[112px] sm:w-[200px] md:top-1/4 md:right-[40px] md:w-[144px] lg:top-1/4 lg:right-[80px] lg:w-[220px]"
                bgClassName="bg-project-no2"
                tag={["Digital Solution", "User Experience"]}
              />
              {/* content */}
              <div
                className="mx-auto
                max-w-2xl
                space-y-3
                py-6
                leading-loose
                text-txt-base
                md:space-y-4
                md:py-8
                lg:space-y-6
                lg:pt-14
                lg:pb-20"
              >
                <Interviewer>プロジェクトの期間を教えてください</Interviewer>
                <Interviewee speaker="A">
                  全体で7ヶ月くらいでした。
                  <Br />
                  SIerからの要件定義を受け、設計開発をトッカシステムズで担当しました。
                  <Br />
                  要件定義を元に、具体的なシステム構成などの提案を行いました。クラウド化するにあたってAWSを利用し、Laravelで開発を行い、フロントエンド含めて納品しました。
                </Interviewee>
                <Interviewer>
                  プロジェクト進行してる時に嬉しいことありましたか？
                </Interviewer>
                <Interviewee speaker="A">
                  今回、プロジェクト未経験のメンバーが初めてテストや設計をしたんです。
                  <Br pc />
                  ソースコードを書いてるのみたら、嬉しくて。しかも、うまくなってきてるのがわかるんですよ。なんだか自分の初心者の時を思い出しちゃいました。
                </Interviewee>
                <Interviewee speaker="B">
                  上手になってきましたか？ありがとうございます！私は、完成した瞬間、本当に嬉しかったです。まだ理解できていないところがいっぱいありますけど、これからもがんばります！
                </Interviewee>
                <Interviewee speaker="C">
                  実装している時にハイになる時があって、それが好きなんです。気持ちが良い！
                </Interviewee>
                <Interviewer>
                  トッカシステムズでの仕事はどうですか？
                </Interviewer>
                <Interviewee speaker="B">
                  私は入社して数ヶ月ですが、オフィスの雰囲気が本当に良いですね。
                </Interviewee>
                <Interviewee speaker="A">
                  一緒に仕事をしやすい人が多いので、分からないことがあっても聞きやすい職場だなと思いました。
                </Interviewee>
                <Interviewee speaker="C">
                  コミュニケーションがとりやすい人、多いですよね。週1ペースで、チームでランチに行ったりしてますね。
                </Interviewee>
                <div className="relative aspect-2/1">
                  <Image
                    src={projectIllust2}
                    alt="ペーパーからクラウドへ。最適な設計とシステムのご提案。"
                    quality={80}
                    layout="fill"
                    objectFit="cover"
                  />
                </div>
                <Interviewer>
                  チームとして一緒に働きたくなるような人はどんな人ですか？
                </Interviewer>
                <Interviewee speaker="B">
                  新しいモノに触れる事に対して、積極的で自主性がある方と働きたいですね。
                </Interviewee>
                <Interviewee speaker="C">
                  プログラム、技術が好きな人。基本的な事だけど、好きなことを追いかけてる人と働きたいです。
                </Interviewee>
                <Interviewer>
                  新しい技術を追いかけるのって辛くないですか？
                </Interviewer>
                <Interviewee speaker="A">
                  フロントエンドは特に早いですよね。新しい物が好きな人は、この業界あうと思います。技術は、どんどん変わりますからね
                </Interviewee>
                <Interviewee speaker="B">
                  業務の中で学ぶことが多いですが、案件が始まる前に、実践で必要な技術に触るようにしています。youtubeなどの技術動画を観るのも勉強になるんですよね。
                </Interviewee>
              </div>
              <ProjectNav />
            </Inner>
          </Container>
        </main>
        <Careers />
        <Contact />
        <Footer />
      </Layout>
    </>
  );
}
